// Code review - In Progress
// Documentation - In Progress
import { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { mainTable } from "../css/Common";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import UsePrevious from "../Hook/UsePrevious";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import DropDown from "../ReusableComponents/DropDown";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import InputText from "../ReusableComponents/InputText";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import { useUserCapability } from "../components/ConstantReducerProvider";
import GridPage from "../components/GridPage";
import {
  contraceptivesGivenExcelExportHeader,
  contraceptivesGivenHeader,
  openingStockExcelExportHeader,
  openingStockHeader,
} from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import MainPopup from "../popup-containers/MainPopup";
import OpeningStockPopup from "../popup-containers/OpeningStockPopup";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";
import ContraceptivesGivenPopUp from "../popup-containers/ContraceptivesGivenPopUp";
const ContraceptivesGiven = () => {
  const location = useLocation();
  const [tableView, setTableView] = useState(true);
  const [addView, setAddView] = useState(false);
  const [deleteButton, setDeleteButton] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [bindCommoditiesCategory, setBindCommoditiesCategory] = useState([]);
  const [bindCommodities, setBindCommodities] = useState([]);
  const [commoditiesCategoryDD, setCommoditiesCategoryDD] = useState([]);
  const [commoditiesUOMDD, setCommoditiesUOMDD] = useState([]);
  const [rowIndex, setRowIndex] = useState("");
  const [commoditiesError, setCommoditiesError] = useState("");
  const [tableError, setTableError] = useState("");
  const [bindBrand, setBindBrand] = useState([]);
  const [popUpOpen, setpopUpOpen] = useState(false);

  const [viewDetails, setViewDetails] = useState(false);
  const [contraceptivesGiven, setContraceptivesGiven] = useState("");
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);

  const [bindMonthDD, setBindMonthDD] = useState([]);
  const [bindYearDD, setBindYearDD] = useState([]);
  const [commoditiesDD, setCommoditiesDD] = useState([]);
  const [commodities, setCommodities] = useState("");

  const [bindContraceptivesGivenData, setBindContraceptivesGivenData] =
    useState([]);
  const [mstContraceptivesGivenId, setMstContraceptivesGivenId] = useState("");
  const [currentData, setCurrentData] = useState({});
  const [currentData1, setCurrentData1] = useState([]);

  const [bindEntityDD, setBindEntityDD] = useState([]);

  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [monthError, setMonthError] = useState("");
  const [yearError, setYearError] = useState("");
  const [entity, setEntity] = useState("");
  const [entityLabel, setEntityLabel] = useState("");
  const [entityError, setEntityError] = useState("");
  const [branchProject, setBranchProject] = useState("");
  const [branchProjectError, setBranchProjectError] = useState("");
  const [sdp, setSDP] = useState("");
  const [sdpError, setSDPError] = useState("");
  const [area, setArea] = useState("");
  const [stockAutoId, setStockAutoId] = useState("");
  const [areaError, setAreaError] = useState("");
  const [outReachWorker, setOutReachWorker] = useState("");
  const [outReachWorkerError, setOutReachWorkerError] = useState("");

  const [bindBranchProject, setBindBranchProject] = useState([]);
  const [getLocationDatas, setGetLocationDatas] = useState([]);
  const [bindSDP, setBindSDP] = useState([]);
  const [bindSDPData, setBindSDPData] = useState([]);
  const [bindOutReachWorker, setBindOutReachWorker] = useState([]);
  const [bindOutReachWorkerData, setBindOutReachWorkerData] = useState([]);
  const [bindAreaDD, setBindAreaDD] = useState([]);
  const [bindAreaDatas, setBindAreaDatas] = useState([]);
  const [stateDropDown, setStateDropDown] = useState([]);
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;

  const [commoditiesCode, setCommoditiesCode] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  const [tableData, setTableData] = useState([
    {
      openingStockCategory: "",
      openingStockName: "",
      openingStockBrand: "",
      batch: "",
      expDate: new Date().toISOString().split("T")[0],
      openingStockOpeningQty: "",
      uom: "",
      uomText: "",
      Charges: "",
      openingStockDate: new Date().toISOString().split("T")[0],
      NameList: [],
      BrandList: [],
      currentStock: "",
    },
  ]);
  const headerData = [
    {
      title: "Category",
      key: "Category",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Name",
      key: "Name",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Brand",
      key: "Brand",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Batch",
      key: "Batch",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Exp. Dt",
      key: "ExpiryDate",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Op. Qty",
      key: "OpQty",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "U.O.M..",
      key: "uom",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Charges",
      key: "Charges",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Date",
      key: "Date",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Action",
      key: "Action",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
  ];
  const previousTableData = UsePrevious(tableData);
  const showAdd = () => {
    setAddView(true);
    setTableView(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    entityLabelValue();
    handleDeleteRow(0);
  };

  const cancel = () => {
    setContraceptivesGiven("");
    setAddView(false);
    setTableView(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);
    setDeleteButton(false);
    setpopUpOpen(false);
    setCommodities("");
    setEntity("");
    setEntityError("");
    setBranchProject("");
    setBranchProjectError("");
    setSDP("");
    setSDPError("");
    setMonthError("");
    setYear("");
    setMonth("");
    setYearError("");
    setArea("");
    setAreaError("");
    setOutReachWorker("");
    setOutReachWorkerError("");
    setBindAreaDD([]);
    setBindSDP([]);
    setTableData([]);
    setTableData([
      {
        openingStockCategory: "",
        openingStockName: "",
        openingStockBrand: "",
        batch: "",
        expDate: new Date().toISOString().split("T")[0],
        openingStockOpeningQty: "",
        uom: "",
        uomText: "",
        Charges: "",
        openingStockDate: new Date().toISOString().split("T")[0],
        NameList: [],
        BrandList: [],
        currentStock: "",
      },
    ]);

    setCommoditiesError("");
    setTableError("");
    setEntityLabel("");
    setCommoditiesCategoryDD([]);
    getOpeningStockDatas();
    setIsLoading(false);
  };

  const appendOpeningStockTableDatas = (rowData) => {
    handleDeleteRow(0);
    let converyArray = [];
    converyArray.push(rowData);
    setTableData([]);
    const formattedEditTableData = converyArray.map((item) => {
      return {
        openingStockCategory: item.MstCommodityCategoryId,
        openingStockName: item.MstCommoditiesId,
        openingStockBrand: item.MstBrandId,
        batch: item.Batch,
        expDate: item.ExpiryDate.split("T")[0],
        openingStockOpeningQty: item.Quantity,
        uom: item.MstCommodityUOMId,
        uomText: item.CommodityUOM,
        Charges: item.Charges,
        openingStockDate: item.Date,
      };
    });

    setTableData((prevData) => [...prevData, ...formattedEditTableData]);
    convertArrayToJSONString(formattedEditTableData);
  };

  const handleEdit = async (rowIndex) => {
    setUpdateScreenTitle(true);
    setAddScreenTitle(false);
    setAddView(true);
    setTableView(false);
    setMonth(bindContraceptivesGivenData[rowIndex].Month);
    setYear(bindContraceptivesGivenData[rowIndex].Year);
    setCommodities(bindContraceptivesGivenData[rowIndex].MstCommodityTypeId);
    appendOpeningStockTableDatas(bindContraceptivesGivenData[rowIndex]);
    setMstContraceptivesGivenId(
      bindContraceptivesGivenData[rowIndex].MstContraceptivesGivenId,
    );
    setEntity(bindContraceptivesGivenData[rowIndex].MstEntityId);
    setBranchProject(bindContraceptivesGivenData[rowIndex].MstBranchProjectId);
    setSDP(bindContraceptivesGivenData[rowIndex].MstSDPId);
    setArea(bindContraceptivesGivenData[rowIndex].MstAreaId);
    setOutReachWorker(bindContraceptivesGivenData[rowIndex].MstUserId);
    entityLabelValue();
  };

  const dropDownDatas = async () => {
    try {
      // Parallel API calls
      const [
        categoryTypeResponse,
        categoryResponse,
        commoditiesResponse,
        entityResponse,
        statesResponse,
        locationResponse,
        sdpResponse,
        commoditiesBrands,
        areaResponse,
        orsNameResponse,
        commoditiesUOM,
      ] = await Promise.all([
        BindAPI("CommoditiesAPI/BindCommodityType"),
        BindAPI("CommoditiesAPI/BindCommodityCategory"),
        BindAPI("CommoditiesAPI/BindCommodities"),
        BindAPI("FPAIOutReachAPI/BindOrgStructure"),
        BindAPI("StateAPI/GetState"),
        BindAPI("LocationAPI/GetLocation"),
        BindAPI("SDPAPI/GetSDP"),
        BindAPI("BrandAPI/BindBrand"),
        BindAPI("AreaAPI/GetArea"),
        BindAPI("InventoryReceiptAPI/BindORSName"),
        BindAPI("CommoditiesAPI/BindCommodityUOM"),
      ]);

      // Utility function for filtering and mapping
      const filterAndMap = (data, mapFn) =>
        data?.Table.filter((item) => item.BlockedBy === null).map(mapFn);

      // Data transformations
      const categoryTypeData = filterAndMap(
        categoryTypeResponse.data,
        (item) => ({
          value: item.MstCommodityTypeId,
          label: item.CommodityType_en,
        }),
      );

      const entityData = entityResponse.data.Table1.map((item) => ({
        value: item.MstEntityId,
        label: item.EntityName,
      }));

      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
        code: item.LocationCode,
      }));

      const statesData = statesResponse.data.Table.map((item) => ({
        value: item.MstStateId,
        label: item.StateName_en,
        code: item?.StateCode,
      }));

      const commoditiesUOMList = commoditiesUOM.data.Table.map((x) => ({
        value: x.MstCommodityUOMId,
        label: x.CommodityUOM,
      }));

      // Set state in a single batch
      setStateDropDown(statesData);
      setBindOutReachWorkerData(orsNameResponse.data.Table1);
      setBindAreaDatas(areaResponse.data.Table);
      setBindSDPData(sdpResponse.data.Table);
      setGetLocationDatas(locationResponse.data.Table);
      setBindBranchProject(locationData);
      setBindEntityDD(entityData);
      setCommoditiesDD(categoryTypeData);
      setBindCommoditiesCategory(
        categoryResponse.data.Table.filter((item) => item.BlockedBy === null),
      );
      setBindCommodities(
        commoditiesResponse.data.Table.filter(
          (item) => item.BlockedBy === null,
        ),
      );
      setBindBrand(
        commoditiesBrands.data.Table.filter((item) => item.BlockedBy === null),
      );
      setCommoditiesUOMDD(commoditiesUOMList);
    } catch (error) {
      console.error("Error in dropDownDatas:", error);
    }
  };

  const getOpeningStockDatas = async () => {
    try {
      setIsLoading(true);
      
      const profile = userProfileDatas[0];

      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // handles null/undefined
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
      };
      
      const response = await BindPostAPI(
        data,
        "ContraceptivesGiven/BindContraceptivesGiven",
      );
      setBindContraceptivesGivenData(response.data.Table);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching Commodities Given data:", error);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        await dropDownDatas();
        await getOpeningStockDatas();
        await getMonthDDValues();
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    })();
  }, []);
  const getMonthDDValues = async () => {
    // Month Dropdown binding
    const response = await BindAPI("MasterDataAPI/BindMonth");
    const getTnxMonthId =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
            value: item.TxnMonthId,
            label: item.MonthName,
          }))
        : [];
    setBindMonthDD(getTnxMonthId);
  };
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [currentYear, currentYear - 1]; // ✅ Only current and previous year

    const yearDropdown = yearsArray.map((year) => ({
      label: year.toString(),
      value: year,
    }));

    setBindYearDD(yearDropdown);
  }, []);
  function validateDataArray(dataArray) {
    let allValid = true;

    dataArray.forEach((data, index) => {
      let errorMessage = "";

      if (data.openingStockCategory === "") {
        errorMessage += ` ${
          index + 1
        }: Commodities Given Category cannot be empty.\n`;
      }
      if (data.batch === "") {
        errorMessage += ` ${index + 1}: Batch No. cannot be empty.\n`;
      }
      if (data.openingStockName === "") {
        errorMessage += ` ${
          index + 1
        }: Commodities Given Commodities GivenName cannot be empty.\n`;
      }

      if (data.openingStockOpeningQty === "") {
        errorMessage += ` ${
          index + 1
        }: Commodities Given Opening Quantity cannot be empty.\n`;
      }

      if (data.uom === "") {
        errorMessage += `${
          index + 1
        }: Unit of Measure (uom) cannot be empty.\n`;
      }

      if (data.openingStockBrand === "") {
        errorMessage += ` ${index + 1}: Commodities Given Brand cannot be empty.\n`;
      }

      if (data.Charges === "") {
        errorMessage += ` ${
          index + 1
        }: Commodities Given Charges cannot be empty.\n`;
      }

      if (errorMessage) {
        setTableError(errorMessage); // Display error message to the user
        allValid = false; // Set allValid to false indicating at least one validation failed
      }
    });

    return allValid; // Return true if all objects are valid, false otherwise
  }
  const validate = (flag) => {
    // Initialize an object to store validation errors for each field
    const errors = {};

    if (flag === 1 || flag === 2) {
      if (entity == "2" || entity == "3") {
        if (!sdp) {
          errors.sdpError = "Select S.D.P.";
        }
      }
      if (entity == "2" || entity == "3") {
        if (!area) {
          errors.areaError = "Select Area";
        }
      }
      if (entity == "3") {
        if (!outReachWorker) {
          errors.outReachWorkerError = "Select OutReach Worker";
        }
      }
      if (!month) {
        errors.month = "Select Month";
      }

      // Validation logic for the Month input
      if (!year) {
        errors.year = "Select Year";
      }
    }
    setSDPError(errors.sdpError || "");
    setAreaError(errors.areaError || "");
    setOutReachWorkerError(errors.outReachWorkerError || "");
    setMonthError(errors.month);
    setYearError(errors.year);
    return errors;
  };
  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    let outputString = "";
    const response = await BindAPI("StateAPI/BindState");
    let stateCode = response.data.Table.filter(
      (x) => x.MstStateId == userProfileDatas[0]?.MstStateId,
    ).map((item) => item?.StateCode)[0];

    const branchProjectCode = bindBranchProject
      .filter((x) => x.value == branchProject)
      .map((item) => item?.code)[0];
    const sdpCode = bindSDP
      .filter((x) => x.value == sdp)
      .map((item) => item?.code)[0];
    const areaCode = bindAreaDD
      .filter((x) => x.value == area)
      .map((item) => item?.code)[0];
    const outReachWorkerName = bindOutReachWorker
      .filter((x) => x.value == outReachWorker)
      .map((item) => item?.label)[0];
    if (entity == 1) {
      outputString = `${stateCode}/${branchProjectCode}/${commoditiesCode}`;
    } else if (entity == 2) {
      outputString = `${stateCode}/${branchProjectCode}/${sdpCode}/${areaCode}/${commoditiesCode}`;
    } else if (entity == 3) {
      outputString = `${stateCode}/${branchProjectCode}/${sdpCode}/${areaCode}/${outReachWorkerName}/${commoditiesCode}`;
    }

    var createdBy = sessionStorage.getItem("createdBy");
    const firstNameValidation = validate(flag);
    if (
      Object.keys(firstNameValidation).length !== 0 ||
      commodities == "" ||
      entity == "" ||
      contraceptivesGiven == "" ||
      branchProject == ""
    ) {
      setIsOpen(true);
      setSubmitBtnDisabled(false);
      setIsLoading(false);
      return;
    }
    if (flag == 1 || flag == 2) {
      if (
        commodities != "" &&
        entity != "" &&
        contraceptivesGiven != "" &&
        branchProject != "" &&
        Object.keys(firstNameValidation).length === 0
      ) {
        setIsOpen(false);
        const contraceptivesGivenDatas = JSON.parse(contraceptivesGiven);
        const isValid = validateDataArray(contraceptivesGivenDatas);

        const filteredWithBlockedByNull3 = bindEntityDD.filter(
          (item) => item.BlockedBy === null,
        );

        if (isValid) {
          setTableError("");
          const openingStockPayload = {
            mstContraceptivesGivenId: mstContraceptivesGivenId
              ? mstContraceptivesGivenId
              : 0,
            month: parseInt(month),
            year: parseInt(year),
            mstCommodityTypeId: commodities,
            entityName: entityLabel,
            mstentityId: parseInt(entity),
            mstBranchProjectId: branchProject,
            mstSDPId: sdp !== "" ? sdp : null,
            mstAreaId: area !== "" ? area : null,
            mstUserId: outReachWorker !== "" ? outReachWorker : null,
            contraceptivesGiven: contraceptivesGiven,
            createdBy: createdBy,
            flag: flag,
          };
          const response = await IUDAPI(
            openingStockPayload,
            "ContraceptivesGiven/IUDContraceptivesGiven",
          );
          if (flag == 1) {
            if (response.data.Table[0].Result === "S") {
              toast.success("Commodities Given Data Inserted Successfully👍", {
                duration: 1000,
                position: "top-center",
              });
              setTimeout(cancel, 1000);
            } else {
              toast.error("Not Insert Commodities Given 👎", {
                duration: 1000,
                position: "top-center",
              });
              setTimeout(cancel, 1000);
            }
          } else if (flag == 2) {
            if (response.data.Table[0].Result === "M") {
              toast.success("Commodities Given Data Updated Successfully👍", {
                duration: 1000,
                position: "top-center",
              });
              setTimeout(cancel, 1000);
            } else {
              toast.error("Not Updated Commodities Given 👎", {
                duration: 1000,
                position: "top-center",
              });
              setTimeout(cancel, 1000);
            }
          } else {
          }
        } else {
          setSubmitBtnDisabled(false);
          setIsLoading(false);
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);

        if (commodities == "") {
          setCommoditiesError("Select Commodities");
        }
        if (entity == "") {
          setEntityError("Select Entity");
        }
        if (entity == "1" || entity == "2" || entity == "3") {
          if (branchProject == "") {
            setBranchProjectError("Select Branch/Project");
          }
        }

        if (contraceptivesGiven.length == 0) {
          setTableError("Fill the above table");
        }
      }
    } else if (flag == 3 || flag == 4 || flag == 5) {
      const openingStockPayload = {
        mstContraceptivesGivenId:
          bindContraceptivesGivenData[items].MstContraceptivesGivenId,
        month: parseInt(month),
        year: parseInt(year),
        mstCommodityTypeId: commodities,
        entityName: entityLabel,
        mstentityId: parseInt(entity),
        mstBranchProjectId: branchProject,
        mstSDPId: sdp !== "" ? sdp : null,
        mstAreaId: area !== "" ? area : null,
        mstUserId: outReachWorker !== "" ? outReachWorker : null,
        contraceptivesGiven: contraceptivesGiven,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI(
        openingStockPayload,
        "ContraceptivesGiven/IUDContraceptivesGiven",
      );
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success(
            "Commodities Given  deleted successfully 🗑️",
            1000,
            cancel(),
          );
          cancel();
        } else {
          toast.error("Failed to delete Commodities Given data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(
            "Commodities Given data blocked successfully 🚫",
            1000,
            cancel(),
          );
          cancel();
        } else {
          toast.error("Failed to block Commodities Given data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success(
            "Commodities Given data unblocked successfully ✅",
            1000,
            cancel(),
          );
          cancel();
        } else {
          toast.error("Failed to unblock Commodities Given data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
    } else {
      setSubmitBtnDisabled(false);
      setIsLoading(false);
    }
  };

  const handleAddRow = () => {
    const newRow = { ...tableData[tableData.length - 1] }; // Copy the last row
    newRow.openingStockCategory = "";
    newRow.openingStockName = "";
    newRow.openingStockBrand = "";
    newRow.batch = "";
    newRow.expDate = new Date().toISOString().split("T")[0];
    newRow.openingStockOpeningQty = "";
    newRow.uom = "";
    newRow.uomText = "";
    newRow.Charges = "";
    newRow.openingStockDate = new Date().toISOString().split("T")[0];
    newRow.NameList = [];
    newRow.BrandList = [];
    newRow.currentStock = "";
    setTableData((prevData) => [...prevData, newRow]);
  };

  const handleDeleteRow = (index) => {
    setTableData((prevData) => {
      const updatedTableData = prevData.filter((_, i) => i !== index);

      // Ensure at least one row exists
      if (updatedTableData.length === 0) {
        const newRow = {
          openingStockCategory: "",
          openingStockName: "",
          openingStockBrand: "",
          batch: "",
          expDate: new Date().toISOString().split("T")[0],
          openingStockOpeningQty: "",
          uom: "",
          uomText: "",
          Charges: "",
          openingStockDate: new Date().toISOString().split("T")[0],
          NameList: [],
          BrandList: [],
          currentStock: "",
        };

        // Use spread to create a new array
        return [newRow];
      }

      convertArrayToJSONString(updatedTableData); // Call convertArrayToJSONString
      return updatedTableData;
    });
  };

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setContraceptivesGiven(jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  const handleInputChange = (input, rowIndex, columnName) => {
    let value = "";

    // Case 1: Dropdown (AutoDropDown sends { value, label })
    if (input && input.value !== undefined && input.label !== undefined) {
      value = input.value;
    }

    // Case 2: Text fields (InputText sends e.target)
    else if (input && input.target) {
      value = input.target.value;
    }

    // Final fallback
    else {
      value = input?.value ?? "";
    }

    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      const updatedRow = { ...updatedData[rowIndex] };

      // Clear dependent fields
      if (columnName === "openingStockCategory") {
        updatedRow.openingStockName = "";
        updatedRow.openingStockBrand = "";
      } else if (columnName === "openingStockName") {
        updatedRow.openingStockBrand = "";
      }

      updatedRow[columnName] = value;

      updatedData[rowIndex] = updatedRow;

      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  const handleOpeningStockDetails = (rowIndex, flag) => {
    handleOpen(true);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
      setRowIndex(rowIndex);
    }
    setCommodities(bindContraceptivesGivenData[rowIndex].MstCommodityTypeId);
    appendOpeningStockTableDatas(bindContraceptivesGivenData[rowIndex]);
    setMstContraceptivesGivenId(
      bindContraceptivesGivenData[rowIndex].mstContraceptivesGivenId,
    );
    setEntity(bindContraceptivesGivenData[rowIndex].MstEntityId);
    setBranchProject(bindContraceptivesGivenData[rowIndex].MstBranchProjectId);
    setSDP(bindContraceptivesGivenData[rowIndex].MstSDPId);
    setArea(bindContraceptivesGivenData[rowIndex].MstAreaId);
    setOutReachWorker(bindContraceptivesGivenData[rowIndex].MstUserId);
    setStockAutoId(bindContraceptivesGivenData[rowIndex].OpStkId);
    entityLabelValue();
    const filterCommoditiesDD = commoditiesDD.filter(
      (x) =>
        x.value == bindContraceptivesGivenData[rowIndex].MstCommodityTypeId,
    );

    const filerCommoditiesCategory = bindCommoditiesCategory
      .filter(
        (x) =>
          x.MstCommodityTypeId ==
          bindContraceptivesGivenData[rowIndex].MstCommodityTypeId,
      )
      .map((item) => ({
        value: item.MstCommodityCategoryId,
        label: item.CommodityCategory_en,
      }))
      .filter(
        (j) =>
          j.value ==
          bindContraceptivesGivenData[rowIndex].MstCommodityCategoryId,
      );

    const filerCommoditiesName = bindCommodities
      .filter(
        (x) =>
          x.MstCommodityCategoryId ==
          bindContraceptivesGivenData[rowIndex].MstCommodityCategoryId,
      )
      .map((item) => ({
        value: item.MstCommoditiesId,
        label: item.CommodityName_en,
      }))
      .filter(
        (j) =>
          j.value == bindContraceptivesGivenData[rowIndex].MstCommoditiesId,
      );

    const filterBrand = bindBrand
      .filter(
        (item) =>
          item.MstCommoditiesId ==
          bindContraceptivesGivenData[rowIndex].MstCommoditiesId,
      )
      .map((x) => ({
        value: x.MstBrandId,
        label: x.Brand_en,
      }))
      .filter(
        (i) => i.value == bindContraceptivesGivenData[rowIndex].MstBrandId,
      );

    const filterUOM = commoditiesUOMDD.filter(
      (x) => x.value == bindContraceptivesGivenData[rowIndex].MstCommodityUOMId,
    );

    const locationrowData = bindContraceptivesGivenData[rowIndex];
    const LocationInfo = getLocationDatas.find(
      (L) => L.MstLocationId === locationrowData.MstBranchProjectId,
    );
    const ResultLocation = {
      value: locationrowData.MstBranchProjectId,
      label: LocationInfo ? LocationInfo.LocationName_en : "DefaultStateLabel",
    };

    const SDProwData = bindContraceptivesGivenData[rowIndex];
    const SDPInfo = bindSDPData.find(
      (SD) => SD.MstSDPId === SDProwData.MstSDPId,
    );
    const ResultSDP = {
      value: SDProwData.MstSDPId,
      label: SDPInfo ? SDPInfo.SDP_en : "DefaultStateLabel",
    };

    const ArearowData = bindContraceptivesGivenData[rowIndex];
    const ArearowDataInfo = bindAreaDatas.find(
      (AT) => AT.MstAreaId === ArearowData.MstAreaId,
    );
    const ResultArea = {
      value: ArearowData.MstAreaId,
      label: ArearowDataInfo
        ? ArearowDataInfo.AreaName_en
        : "DefaultStateLabel",
    };

    const outReachWorkerDropdown = bindContraceptivesGivenData[rowIndex];
    const outReachWorkerInfo = bindOutReachWorkerData.find(
      (SD) => SD.MstUserId === outReachWorkerDropdown.MstUserId,
    );
    const ResultOutReachWorker = {
      value: outReachWorkerDropdown.MstUserId,
      label: outReachWorkerInfo
        ? outReachWorkerInfo.FirstName_en
        : "DefaultStateLabel",
    };

    const MonthrowData = bindContraceptivesGivenData[rowIndex];
    const MonthInfo = bindMonthDD.find((SD) => SD.value === MonthrowData.Month);
    const ResultMonth = {
      value: MonthrowData.Month,
      label: MonthInfo ? MonthInfo.label : "DefaultStateLabel",
    };

    const YearrowData = bindContraceptivesGivenData[rowIndex];
    const YearInfo = bindYearDD.find((SD) => SD.value === YearrowData.Year);
    const ResultYear = {
      value: YearrowData.Year,
      label: YearInfo ? YearInfo.label : "DefaultStateLabel",
    };

    const allDatas = [
      bindContraceptivesGivenData[rowIndex].MstCommodityTypeId,
      filterCommoditiesDD,
      filerCommoditiesCategory,
      filerCommoditiesName,
      filterBrand,
      filterUOM,
      ResultLocation,
      ResultSDP,
      ResultArea,
      ResultOutReachWorker,
      bindContraceptivesGivenData[rowIndex].MstEntityId,
      ResultMonth,
      ResultYear,
    ];
    setCurrentData(allDatas);

    let converyArray = [];
    converyArray.push(bindContraceptivesGivenData[rowIndex]);
    const formattedEditTableData = converyArray.map((item) => {
      return {
        openingStockCategory: item.MstCommodityCategoryId,
        openingStockName: item.MstCommoditiesId,
        openingStockBrand: item.MstBrandId,
        batch: item.Batch,
        expDate: item.ExpiryDate.split("T")[0],
        openingStockOpeningQty: item.Quantity,
        uom: item.MstCommodityUOMId,
        uomText: item.CommodityUOM,
        Charges: item.Charges,
        openingStockDate: item.Date.split("T")[0],
      };
    });
    setCurrentData1(formattedEditTableData);
  };

  const handleCategoryDropDown = (value) => {
    setCommodities(value.value);
    setCommoditiesError("");

    // Clear openingStockCategory for all rows in tableData
    setTableData((prevTableData) => {
      const updatedData = prevTableData.map((row) => ({
        ...row,
        openingStockCategory: "", // Clear the openingStockCategory value
        openingStockName: "", // Also clear dependent fields
        openingStockBrand: "", // Clear further dependent fields
      }));
      convertArrayToJSONString(updatedData); // Update JSON string
      return updatedData;
    });
  };

  useEffect(() => {
    if (commodities) {
      const getFilteredCategory = bindCommoditiesCategory
        .filter((item) => item.MstCommodityTypeId == commodities)
        .map((items) => ({
          value: items.MstCommodityCategoryId,
          label: items.CommodityCategory_en,
        }));

      setCommoditiesCategoryDD(getFilteredCategory);

      if (commodities == 1) {
        setCommoditiesCode("CPT");
      }

      if (commodities == 2) {
        setCommoditiesCode("MED");
      }

      if (commodities == 3) {
        setCommoditiesCode("SOC");
      }

      if (commodities == 4) {
        setCommoditiesCode("CON");
      }
    } else {
    }
  }, [commodities]);

  useEffect(() => {
    const updateTableData = async () => {
      const currentTableData = [...tableData];

      for (const row of currentTableData) {
        // Update NameList based on openingStockCategory
        if (row?.openingStockCategory) {
          const selectedCommoditiesCategory = bindCommodities
            .filter(
              (item) =>
                item.MstCommodityCategoryId === row.openingStockCategory,
            )
            .map((item) => ({
              value: item.MstCommoditiesId,
              label: item.CommodityName_en,
              uom: item.MstCommodityUOMId,
              uomLabel: item.CommodityUOM,
            }));

          row.NameList = selectedCommoditiesCategory;

          const selectedCommodity = selectedCommoditiesCategory.find(
            (item) => item.value === row.openingStockName,
          );

          if (selectedCommodity) {
            row.uomText = selectedCommodity.uomLabel;
            row.uom = selectedCommodity.uom;
          } else {
            row.uomText = "";
            row.uom = ""; // Reset if no selected commodity
          }
        }

        // Update BrandList based on openingStockName
        if (row?.openingStockName) {
          const selectedCommoditiesName = bindBrand
            .filter((item) => item.MstCommoditiesId === row.openingStockName)
            .map((x) => ({
              value: x.MstBrandId,
              label: x.Brand_en,
            }));
          row.BrandList = selectedCommoditiesName;
        }

        // Fetch current stock for openingStockBrand
      }

      // Update tableData with new values
      setTableData(currentTableData);
    };

    // Only trigger the update if data has changed
    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      updateTableData();
    }
  }, [tableData]);

  useEffect(() => {
    const branchProjectSelectedValue = bindSDPData.find(
      (item) => item.MstLocationId == branchProject, // Replace with the desired MstStateId
    );

    if (branchProjectSelectedValue) {
      const branchProjectLabels = bindSDPData
        .filter(
          (item) =>
            item.MstLocationId === branchProjectSelectedValue.MstLocationId,
        )
        .map((item) => ({
          MstSDPId: item.MstSDPId,
          SDP_en: item.SDP_en,
          SDPCode: item.SDPCode,
        }));

      const branchProjectSelected = branchProjectLabels.map((AR) => ({
        value: AR.MstSDPId, // Replace with the appropriate value
        label: AR.SDP_en,
        code: AR.SDPCode,
      }));

      setBindSDP(branchProjectSelected);
    } else {
      console.log("stateSelectedValue is undefined or not found.");
    }
  }, [branchProject ? branchProject : null]);

  useEffect(() => {
    // Find the selected state in getLocationDatas
    const areaSelectedValue = bindAreaDatas.find(
      (item) => item.MstSDPId == sdp, // Replace with the desired MstStateId
    );

    if (areaSelectedValue) {
      const areaLabels = bindAreaDatas
        .filter((item) => item.MstSDPId === areaSelectedValue.MstSDPId)
        .map((item) => ({
          MstAreaId: item.MstAreaId,
          AreaName_en: item.AreaName_en,
          AreaCode: item.AreaCode,
        }));

      const areaSelected = areaLabels.map((AR) => ({
        value: AR.MstAreaId, // Replace with the appropriate value
        label: AR.AreaName_en,
        code: AR.AreaCode,
      }));

      setBindAreaDD(areaSelected);
    } else {
      console.log("stateSelectedValue is undefined or not found.");
    }
  }, [sdp ? sdp : null]);

  useEffect(() => {
    setBindOutReachWorker([]);
    const sdpSelectedValue = bindOutReachWorkerData.find(
      (item) => item.MstSDPId == sdp, // Replace with the desired MstStateId
    );

    if (sdpSelectedValue) {
      const sdpLabels = bindOutReachWorkerData
        .filter((item) => item.MstSDPId === sdpSelectedValue.MstSDPId)
        .map((item) => ({
          MstUserId: item.MstUserId,
          FirstName_en: item.FirstName_en,
        }));

      const sdpSelected = sdpLabels.map((AR) => ({
        value: AR.MstUserId, // Replace with the appropriate value
        label: AR.FirstName_en,
      }));

      setBindOutReachWorker(sdpSelected);
    } else {
      console.log("stateSelectedValue is undefined or not found.");
    }
  }, [sdp ? sdp : null]);

  const entityLabelValue = () => {
    if (entity) {
      const entityDataDropDown = bindEntityDD.find(
        (item) => item.value == entity,
      );

      const entityLabel = {
        value: entity,
        label: entityDataDropDown ? entityDataDropDown.label : "Unknown",
      };
      setEntityLabel(entityLabel.label);
    }
  };

  useEffect(() => {
    if (addScreenTitle || updateScreenTitle) {
      entityLabelValue();
    }
  }, [entity]);

  useEffect(() => {
    if (location.pathname == "/contraceptivesgiven") {
      setAddScreenTitle(false);
      setTableView(true);
      getOpeningStockDatas();
    }
  }, [location]);

  const getUserOrganizationDatas = () => {
    if (userProfileDatas && userProfileDatas[0]) {
      setBranchProject(userProfileDatas[0]?.MstLocationId);
      setSDP(userProfileDatas[0]?.MstSDPId);
    }
  };

  const handleExport = async () => {
    const profile = userProfileDatas[0];
    const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // handles null/undefined
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
      };
      
      const locationResponse = await BindPostAPI(
        data,
       "ContraceptivesGiven/ExcelExportContraceptivesGiven",
      );
    // const locationResponse = await BindAPI(
    //   "ContraceptivesGiven/ExcelExportContraceptivesGiven",
    // );

    // ✅ EXPORT WITH LOCAL DATA (IMMEDIATE)
    exportData(
      contraceptivesGivenExcelExportHeader?.map((column) => column.title),
      locationResponse?.data?.Table,
    );
  };

  const exportData = (columns, rows, dateRange, selectedDetails) => {
    // Title row configuration
    const titleRow = [
      {
        v: "Commodities Given",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    // Add "Row Total" to headers
    const headerRow = [
      ...columns?.map((column) => ({
        v: column,
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "left" },
        },
      })),
    ];

    const dataRows = rows?.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const rowStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        { v: index + 1, s: rowStyle },

        { v: rowData.MstContraceptivesGivenId, s: rowStyle },
        { v: rowData.Date, s: rowStyle },
        { v: rowData.MonthName, s: rowStyle },
        { v: rowData.Year, s: rowStyle },
        { v: rowData.CommodityType_en, s: rowStyle },
        { v: rowData.EntityName, s: rowStyle },
        { v: rowData.LocationName_en, s: rowStyle },

        { v: rowData.SDP_en, s: rowStyle },
        { v: rowData.AreaName_en, s: rowStyle },
        { v: rowData.OutreachStaff, s: rowStyle },
        { v: rowData.CommodityCategory_en, s: rowStyle },

        { v: rowData.CommodityName_en, s: rowStyle },
        { v: rowData.Brand_en, s: rowStyle },
        { v: rowData.Batch, s: rowStyle },
        { v: rowData.ExpiryDate, s: rowStyle },

        { v: rowData.Quantity, s: rowStyle },
        { v: rowData.CommodityUOM, s: rowStyle },

        { v: rowData.Charges, s: rowStyle },
        { v: rowData.CreatedBy, s: rowStyle },
      ];
    });

    // Combine all rows
    const wsData = [titleRow, headerRow, ...dataRows];
    // const wsData = [headerRow, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Set custom column widths
    ws["!cols"] = [
      { width: 8 }, // Index
      { width: 20 }, // Branch
      { width: 20 }, // Branch
      { width: 20 }, // Branch
      { width: 20 }, // Branch
      { width: 20 }, // Branch
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Services
      { width: 30 }, // Female Child
      { width: 30 }, // Male Child
      { width: 30 }, // Other Child
      { width: 30 }, // Row Total
      { width: 30 }, // Services
      { width: 30 }, // Female Child
      { width: 30 }, // Male Child
      { width: 30 }, // Other Child
      { width: 30 }, // Row Total
      { width: 30 }, // Row Total
    ];

    ws["!rows"] = [
      { hpt: 30 }, // Title row height
      { hpt: 15 }, // Date range row height
      { hpt: 15 }, // Branch row height (taller for wrapped content)
      { hpt: 15 }, // Spacing row height
      { hpt: 15 }, // Header row height (taller for wrapped content)
      ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
      { hpt: 15 }, // Totals row height
    ];

    // Apply borders and styles
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          // Add borders to all cells
          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Commodities Given.xlsx");
  };
  const isWithinThreeMonths = (expDate) => {
    if (!expDate) return false;

    const today = new Date();
    const expiry = new Date(expDate);

    const threeMonthsLater = new Date();
    threeMonthsLater.setMonth(today.getMonth() + 3);

    return expiry >= today && expiry <= threeMonthsLater;
  };

  return (
    <MainLayout pageName="3">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {tableView && (
        <GridPage
          title={`Commodities Given`}
          header={contraceptivesGivenHeader}
          records={bindContraceptivesGivenData ?? []}
          handleEdit={handleEdit}
          handleAction={handleOpeningStockDetails}
          showAdd={showAdd}
          blockView={true}
          handleExport={handleExport}
          handleExportBtn={true}
          xScroll="max-md:w-fit md:w-fit w-full"
        />
      )}
      {addView && (
        <div className="flex flex-col w-full">
          <div className={mainTable.mainAddScreen}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Commodities Given"
            />
            <div className={mainTable.addShadowScreen}>
              <div className={mainTable.mainContentScreen}>
                <form className="p-5 min-h-[60vh] max-h-[72vh]">
                  <div className="sm:grid gap-4 mb-6 md:grid-cols-3">
                    <AutoDropDown
                      classStar="text-red-500"
                      title="Month"
                      options={bindMonthDD}
                      placeholder="Select"
                      name="month"
                      selectedOption={bindMonthDD.find((x) => x.value == month)}
                      Class="custom-class"
                      tabIndex="1"
                      controlFunc={(value, e) => {
                        setMonth(value.value);
                      }}
                      controlFuncBlur={(value, e) => {
                        setMonthError(month ? "" : "Select Month");
                      }}
                      errorMessage={monthError?.monthError}
                      setError={setMonthError}
                    />
                    <AutoDropDown
                      classStar="text-red-500"
                      title="Year"
                      options={bindYearDD}
                      placeholder="Select"
                      name="year"
                      selectedOption={bindYearDD.find((x) => x.value == year)}
                      Class="custom-class"
                      tabIndex="1"
                      controlFunc={(value, e) => {
                        setYear(value.value);
                      }}
                      controlFuncBlur={(value, e) => {
                        setYearError(year ? "" : "Select Year");
                      }}
                      errorMessage={yearError?.yearError}
                      setError={setYearError}
                    />
                    <AutoDropDown
                      Class="Custom-class"
                      title="Commodities"
                      options={commoditiesDD}
                      classStar="text-red-500"
                      placeholder="Select"
                      name="commodities"
                      selectedOption={commoditiesDD.find(
                        (x) => x.value == commodities,
                      )}
                      controlFunc={handleCategoryDropDown}
                      errorMessage={commoditiesError?.commoditiesError}
                      setError={setCommoditiesError}
                    />
                    <div>
                      <DropDown
                        title="Entity"
                        classStar="text-red-500"
                        options={bindEntityDD}
                        placeholder="Select"
                        name="entity"
                        selectedOption={entity}
                        controlFunc={(e) => {
                          setBranchProject("");
                          setSDP("");
                          setArea("");
                          setOutReachWorker("");
                          setEntity(e.target.value);
                          getUserOrganizationDatas();
                        }}
                        controlFuncBlur={(e) => {
                          setEntityError(e.target.value ? "" : "Select Entity");
                        }}
                      />
                      {entityError && (
                        <div className="text-red-500">{entityError}</div>
                      )}
                    </div>

                    {entity && (
                      <div>
                        <AutoDropDown
                          title="Branch/Project"
                          classStar="text-red-500"
                          options={
                            userProfileDatas[0]?.MstLocationId
                              ? bindBranchProject.filter(
                                  (x) =>
                                    x.value ==
                                    userProfileDatas[0]?.MstLocationId,
                                )
                              : bindBranchProject
                          }
                          placeholder="Select"
                          name="branchProject"
                          selectedOption={
                            branchProject
                              ? bindBranchProject.find(
                                  (x) => x.value == branchProject,
                                )
                              : ""
                          }
                          Class="custom-class"
                          tabIndex="1"
                          controlFunc={(value) => {
                            setSDP("");
                            setArea("");
                            setOutReachWorker("");
                            setBranchProject(value.value);
                            setBranchProjectError(
                              value ? "" : "Select Branch/Project",
                            );
                            //    handleBranchOPId();
                          }}
                          controlFuncBlur={() => {
                            setBranchProjectError(
                              branchProject ? "" : "Select Branch/Project",
                            );
                          }}
                        />
                        {branchProjectError && (
                          <span className="text-red-500">
                            {branchProjectError}
                          </span>
                        )}
                      </div>
                    )}
                    {(entity == "2" || entity == "3") && (
                      <div>
                        <AutoDropDown
                          title="S.D.P."
                          classStar="text-red-500"
                          options={bindSDP}
                          placeholder="Select"
                          name="sdp"
                          selectedOption={
                            sdp ? bindSDP.find((x) => x.value == sdp) : ""
                          }
                          Class="custom-class"
                          tabIndex="1"
                          controlFunc={(value) => {
                            setArea("");
                            setOutReachWorker("");
                            setSDP(value.value);
                            setSDPError(value ? "" : "Select S.P.D.");
                          }}
                          controlFuncBlur={() => {
                            setSDPError(sdp ? "" : "Select S.P.D.");
                          }}
                        />
                        {sdpError && (
                          <span className="text-red-500">{sdpError}</span>
                        )}
                      </div>
                    )}

                    {(entity == "2" || entity == "3") && (
                      <AutoDropDown
                        title="Area Name"
                        options={bindAreaDD}
                        name="area"
                        classStar="text-red-500"
                        placeholder="Select"
                        Class="custom-class"
                        selectedOption={
                          area ? bindAreaDD.find((x) => x.value == area) : ""
                        }
                        controlFunc={(value) => {
                          setArea(value.value);
                          setAreaError(value ? "" : "Select Area");
                        }}
                        controlFuncBlur={() => {
                          setAreaError(area ? "" : "Select Area");
                        }}
                        errorMessage={areaError?.areaError}
                        setError={ setAreaError}
                        
                      />
                    )}

                    {entity == "3" && (
                      <AutoDropDown
                        title="Outreach staff"
                        options={bindOutReachWorker}
                        name="outReachWorker"
                        classStar="text-red-500"
                        placeholder="Select"
                        Class="custom-class"
                        selectedOption={
                          outReachWorker
                            ? bindOutReachWorker.find(
                                (x) => x.value == outReachWorker,
                              )
                            : ""
                        }
                        controlFunc={(value) => {
                          setOutReachWorker(value.value);
                          setOutReachWorkerError(
                            value ? "" : "Select OutReach Worker",
                          );
                        }}
                        controlFuncBlur={() => {
                          setOutReachWorkerError(
                            outReachWorker ? "" : "Select OutReach Worker",
                          );
                        }}
                        errorMessage={outReachWorkerError?.outReachWorkerError}
                        setError={ setOutReachWorkerError}

                      />
                    )}

                    <div className=" col-span-3">
                      <div className="hidden md:block overflow-x-auto overflow-y-none max-h-max relative ">
                        <div className="overflow-y-none w-screen">
                          <table className="w-full border border-gray-300 mt-6">
                            <thead>
                              <tr>
                                <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-96">
                                  Category
                                </th>
                                <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-96">
                                  Name
                                </th>
                                <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-96">
                                  Brand
                                </th>
                                <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                                  Batch
                                </th>
                                <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-12">
                                  Exp. Dt.
                                </th>
                                <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                                  Quantity
                                </th>

                                <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-52">
                                  U.O.M.
                                </th>
                                <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-52">
                                  Value
                                </th>
                                <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-12">
                                  Date
                                </th>
                                {addScreenTitle && (
                                  <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                                    Action
                                  </th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {tableData.map((row, index) => (
                                <tr key={index}>
                                  <td className="border border-gray-300 p-2">
                                    <AutoDropDown
                                      Class="Custom-class"
                                      options={commoditiesCategoryDD}
                                      placeholder="Select"
                                      name="Category"
                                      selectedOption={commoditiesCategoryDD.find(
                                        (x) =>
                                          x.value == row.openingStockCategory,
                                      )}
                                      controlFunc={(e) => {
                                        handleInputChange(
                                          e,
                                          index,
                                          "openingStockCategory",
                                        );
                                      }}
                                    />
                                  </td>
                                  <td className="border border-gray-300 p-2">
                                    <AutoDropDown
                                      Class="Custom-class"
                                      options={row.NameList ?? []}
                                      placeholder="Select"
                                      name="openingStockName"
                                      selectedOption={row.NameList?.find(
                                        (x) => x.value == row.openingStockName,
                                      )}
                                      controlFunc={(e) => {
                                        handleInputChange(
                                          e,
                                          index,
                                          "openingStockName",
                                        );
                                      }}
                                    />
                                  </td>
                                  <td className="border border-gray-300 p-2">
                                    <AutoDropDown
                                      options={row.BrandList ?? []}
                                      name="openingStockBrand"
                                      selectedOption={row.BrandList?.find(
                                        (x) => x.value == row.openingStockBrand,
                                      )}
                                      placeholder="Select"
                                      Class="custom-class"
                                      tabIndex="1"
                                      controlFunc={(e) => {
                                        handleInputChange(
                                          e,
                                          index,
                                          "openingStockBrand",
                                        );
                                      }}
                                    />
                                  </td>
                                  <td className="border border-gray-300 p-2">
                                    <InputText
                                      inputType="text"
                                      name="batch"
                                      maxLength={40}
                                      content={row.batch}
                                      controlFunc={(e) => {
                                        handleInputChange(
                                          e.target,
                                          index,
                                          "batch",
                                        );
                                      }}
                                    />
                                  </td>
                                  {/* <td className="border border-gray-300 p-2">
                                                                        <InputText
                                                                            inputType="date"
                                                                            name="expDate"
                                                                            content={row.expDate}
                                                                            controlFunc={(e) => {
                                                                                handleInputChange(
                                                                                    e.target,
                                                                                    index,
                                                                                    "expDate"
                                                                                );
                                                                            }}
                                                                            min={
                                                                                new Date().toISOString().split("T")[0]
                                                                            }
                                                                        />
                                                                    </td> */}
                                  <td
                                    className={`border border-gray-300 p-2 ${
                                      isWithinThreeMonths(row.expDate)
                                        ? "bg-red-500"
                                        : ""
                                    }`}
                                  >
                                    <InputText
                                      inputType="date"
                                      name="expDate"
                                      content={row.expDate}
                                      controlFunc={(e) => {
                                        handleInputChange(
                                          e.target,
                                          index,
                                          "expDate",
                                        );
                                      }}
                                      min={
                                        new Date().toISOString().split("T")[0]
                                      }
                                    />
                                  </td>

                                  <td className="border border-gray-300 p-2">
                                    <div
                                      title={`Min Stock: ${
                                        row.currentStock || 0
                                      }`}
                                    >
                                      <InputText
                                        inputType="text"
                                        name="openingStockOpeningQty"
                                        content={row.openingStockOpeningQty}
                                        controlFunc={(e) => {
                                          handleInputChange(
                                            e.target,
                                            index,
                                            "openingStockOpeningQty",
                                          );
                                        }}
                                        controlFuncBlur={(e) => {
                                          const inputValue = e.target.value;

                                          // Validate the value when the user leaves the field
                                          if (
                                            inputValue !== "" &&
                                            parseFloat(inputValue) <
                                              (row.currentStock || 0)
                                          ) {
                                            handleInputChange(
                                              { value: "" },
                                              index,
                                              "openingStockOpeningQty",
                                            ); // Clear the value if invalid
                                          }
                                        }}
                                      />
                                    </div>
                                  </td>
                                  <td className="border border-gray-300 p-2">
                                    <InputText
                                      type="text"
                                      content={row.uomText}
                                      disabled={true}
                                      controlFunc={(e) => {
                                        handleInputChange(
                                          e.target,
                                          index,
                                          "uomText",
                                        );
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <InputText
                                      inputType="text"
                                      name="Charges"
                                      content={row.Charges}
                                      controlFunc={(e) => {
                                        handleInputChange(
                                          e.target,
                                          index,
                                          "Charges",
                                        );
                                      }}
                                    />
                                  </td>

                                  <td className="border border-gray-300 p-2">
                                    <InputText
                                      inputType="date"
                                      content={
                                        row.openingStockDate.split("T")[0]
                                      }
                                      maxLength={5}
                                      controlFunc={(e) => {
                                        handleInputChange(
                                          e.target,
                                          index,
                                          "openingStockDate",
                                        );
                                      }}
                                      min={
                                        new Date().toISOString().split("T")[0]
                                      }
                                    />
                                  </td>
                                  {addScreenTitle && (
                                    <td className="border border-gray-300">
                                      <div className="flex gap-4 align-baseline items-center justify-center">
                                        <svg
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                          class="w-6 h-6 text-black cursor-pointer"
                                          onClick={() => handleDeleteRow(index)}
                                        >
                                          <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                                        </svg>
                                        <svg
                                          viewBox="0 0 1024 1024"
                                          fill="currentColor"
                                          onClick={handleAddRow}
                                          class="w-6 h-6 text-black cursor-pointer"
                                        >
                                          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                                        </svg>
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="text-red-500">{tableError}</div>
                    </div>
                    <div className={mainTable.tableMobile} role="table">
                      <div className="w-full md:overflow-y-auto lg:h-96 h-full">
                        {tableData.length > 0 &&
                          tableData.map((row, index) => (
                            <div scope="col" class={mainTable.mobileTable}>
                              {headerData.map((keyData) => (
                                <div
                                  scope="cell"
                                  class={mainTable.tableData}
                                  role="cell"
                                >
                                  {keyData.key === "Action" ? (
                                    <div class={mainTable.tableData}>
                                      <div className="md:block hidden">
                                        <button
                                          id="dropdownMenuIconButton"
                                          data-dropdown-toggle="dropdownDots"
                                          class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none  focus:ring-gray-50 "
                                          type="button"
                                        >
                                          <svg
                                            class="w-6 h-6"
                                            aria-hidden="true"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                                          </svg>
                                        </button>
                                      </div>
                                      <div className="md:hidden flex justify-center">
                                        <input
                                          type="button"
                                          className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
                                          onClick={handleAddRow}
                                          value="Add"
                                        />
                                        <input
                                          type="button"
                                          className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
                                          onClick={() => handleDeleteRow(index)}
                                          value="Delete"
                                        />
                                      </div>
                                    </div>
                                  ) : keyData.key === "Category" ? (
                                    <div className=" border p-1">
                                      <div className="flex items-center w-full font-bold">
                                        {keyData.title}
                                      </div>
                                      <AutoDropDown
                                        Class="Custom-class"
                                        options={commoditiesCategoryDD}
                                        placeholder="Select"
                                        name="Category"
                                        selectedOption={commoditiesCategoryDD.find(
                                          (x) =>
                                            x.value == row.openingStockCategory,
                                        )}
                                        controlFunc={(e) => {
                                          handleInputChange(
                                            e,
                                            index,
                                            "openingStockCategory",
                                          );
                                        }}
                                      />
                                    </div>
                                  ) : keyData.key === "Name" ? (
                                    <div className=" border p-1">
                                      <div className="flex items-center w-full font-bold">
                                        {keyData.title}
                                      </div>
                                      <AutoDropDown
                                        Class="Custom-class"
                                        options={row.NameList ?? []}
                                        placeholder="Select"
                                        name="openingStockName"
                                        selectedOption={row.NameList?.find(
                                          (x) =>
                                            x.value == row.openingStockName,
                                        )}
                                        controlFunc={(e) => {
                                          handleInputChange(
                                            e,
                                            index,
                                            "openingStockName",
                                          );
                                        }}
                                      />
                                    </div>
                                  ) : keyData.key === "Brand" ? (
                                    <div className=" border p-1">
                                      <div className="flex items-center w-full font-bold">
                                        {keyData.title}
                                      </div>
                                      <AutoDropDown
                                        options={row.BrandList ?? []}
                                        name="openingStockBrand"
                                        selectedOption={row.BrandList?.find(
                                          (x) =>
                                            x.value == row.openingStockBrand,
                                        )}
                                        placeholder="Select"
                                        Class="custom-class"
                                        tabIndex="1"
                                        controlFunc={(e) => {
                                          handleInputChange(
                                            e,
                                            index,
                                            "openingStockBrand",
                                          );
                                        }}
                                      />
                                    </div>
                                  ) : keyData.key === "Batch" ? (
                                    <div className=" border p-1">
                                      <div className="flex items-center w-full font-bold">
                                        {keyData.title}
                                      </div>
                                      <InputText
                                        inputType="text"
                                        name="batch"
                                        maxLength={40}
                                        content={row.batch}
                                        controlFunc={(e) => {
                                          handleInputChange(
                                            e.target,
                                            index,
                                            "batch",
                                          );
                                        }}
                                      />
                                    </div>
                                  ) : keyData.key === "ExpiryDate" ? (
                                    <div className=" border p-1">
                                      <div className="flex items-center w-full font-bold">
                                        {keyData.title}
                                      </div>
                                      <InputText
                                        inputType="date"
                                        name="expDate"
                                        content={row.expDate}
                                        controlFunc={(e) => {
                                          handleInputChange(
                                            e.target,
                                            index,
                                            "expDate",
                                          );
                                        }}
                                        min={
                                          new Date().toISOString().split("T")[0]
                                        }
                                      />
                                    </div>
                                  ) : keyData.key === "OpQty" ? (
                                    <div className=" border p-1">
                                      <div className="flex items-center w-full font-bold">
                                        {keyData.title}
                                      </div>
                                      <div
                                        title={`Min Stock: ${
                                          row.currentStock || 0
                                        }`}
                                      >
                                        <InputText
                                          inputType="text"
                                          name="openingStockOpeningQty"
                                          content={row.openingStockOpeningQty}
                                          controlFunc={(e) => {
                                            handleInputChange(
                                              e.target,
                                              index,
                                              "openingStockOpeningQty",
                                            );
                                          }}
                                          controlFuncBlur={(e) => {
                                            const inputValue = e.target.value;

                                            // Validate the value when the user leaves the field
                                            if (
                                              inputValue !== "" &&
                                              parseFloat(inputValue) <
                                                (row.currentStock || 0)
                                            ) {
                                              handleInputChange(
                                                { value: "" },
                                                index,
                                                "openingStockOpeningQty",
                                              ); // Clear the value if invalid
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>
                                  ) : keyData.key === "uom" ? (
                                    <div className=" border p-1">
                                      <div className="flex items-center w-full whitespace-nowrap font-bold">
                                        {keyData.title}
                                      </div>
                                      <InputText
                                        type="text"
                                        content={row.uomText}
                                        disabled={true}
                                        controlFunc={(e) => {
                                          handleInputChange(
                                            e.target,
                                            index,
                                            "uomText",
                                          );
                                        }}
                                      />
                                    </div>
                                  ) : keyData.key === "Charges" ? (
                                    <div className=" border p-1">
                                      <div className="flex items-center w-full whitespace-nowrap font-bold">
                                        {keyData.title}
                                      </div>
                                      <InputText
                                        inputType="text"
                                        name="Charges"
                                        content={row.Charges}
                                        controlFunc={(e) => {
                                          handleInputChange(
                                            e.target,
                                            index,
                                            "Charges",
                                          );
                                        }}
                                      />
                                    </div>
                                  ) : keyData.key === "Date" ? (
                                    <div className=" border p-1">
                                      <div className="flex items-center w-full whitespace-nowrap font-bold">
                                        {keyData.title}
                                      </div>
                                      <InputText
                                        inputType="date"
                                        content={row.openingStockDate}
                                        maxLength={5}
                                        controlFunc={(e) => {
                                          handleInputChange(
                                            e.target,
                                            index,
                                            "openingStockDate",
                                          );
                                        }}
                                        min={
                                          new Date().toISOString().split("T")[0]
                                        }
                                      />
                                    </div>
                                  ) : (
                                    <div className="flex border p-1">
                                      <div className="flex basis-1/2 font-bold">
                                        {keyData.title}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="md:hidden">
                      {tableError && (
                        <div className="text-red-500">{tableError}</div>
                      )}
                    </div>
                  </div>
                  <Buttons
                    addScreenTitle={addScreenTitle}
                    updateScreenTitle={updateScreenTitle}
                    handleSubmit={handleSubmit}
                    disabledBtn={submitBtnDisabled ? true : false}
                    cancel={cancel}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleOpeningStockDetails}
      >
        <div>
          <PopUpScreenTitle
            title="Commodities Given"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <ContraceptivesGivenPopUp data={currentData} data1={currentData1} />
        </div>
        <PopUpButtons
          deleteDetails={deleteButton ? false : deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          disabledBtn={submitBtnDisabled ? true : false}
          cancel={cancel}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default ContraceptivesGiven;
